// extracted by mini-css-extract-plugin
module.exports = {"scroll-container":"OverviewPopper_scroll-container__hmRte","scroll-container-dark":"OverviewPopper_scroll-container-dark__H9lrw"};